import React, { useContext, useRef, useState } from 'react';
import Grid from "@material-ui/core/Grid";
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { ModalContext } from '../../contexts/modal';
import { useForceRegistery } from '../../services/device';


export default function RegisterDeviceButton() {

    const { setOpen, setContent } = useContext(ModalContext)

    function handleClick() {
        setContent(<RegisterDeviceModal />)
        setOpen(true)
    }

    return (
        <Button variant='contained' color='primary' onClick={handleClick}>فعال‌سازی دستگاه جدید</Button>
    );
}


function RegisterDeviceModal() {

    const { setOpen } = useContext(ModalContext)

    const nationalIdRef = useRef();
    const phoneNumberRef = useRef();
    const imeiRef = useRef();
    const nameRef = useRef();
    const dayOfBirthRef = useRef();
    const yearOfBirthRef = useRef();

    const [month, setMonth] = useState("");
    const [province, setProvince] = useState("");

    const forceRegistery = useForceRegistery()

    async function handleSubmit(e) {
        e.preventDefault();
        const data = {
            nationalId: nationalIdRef.current.value,
            imei: imeiRef.current.value,
            phoneNumber: phoneNumberRef.current.value,
            name: nameRef.current.value,
            province: province,
            dateOfBirth: `${yearOfBirthRef.current.value}-${month}-${dayOfBirthRef.current.value}`
        };
        try {
            const success = await forceRegistery(data)
            if (success)
                setOpen(false)
        } catch {

        }

    }

    const classes = useStyles()

    return (
        <form onSubmit={handleSubmit}>
            <Typography align="left" variant="h6" className={classes.title}>
                ثبت اطلاعات کاربر
            </Typography>
            <div>
                <TextField label="نام کامل" size="small" variant="filled" fullWidth
                    inputRef={nameRef} inputProps={{ pattern: "[0-9]{10}" }} />
            </div>
            <div className={classes.input}>
                <TextField label="کد ملی" size="small" variant="filled" fullWidth
                    inputRef={nationalIdRef} inputProps={{ pattern: "[0-9]{10}" }} required />
            </div>
            <div className={classes.input}>
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <TextField label="روز تولد" type="number" size="small" variant="filled" fullWidth
                            inputProps={{ min: 0, max: 31 }} inputRef={dayOfBirthRef} required />

                    </Grid>
                    <Grid item xs={4}>
                        <FormControl variant="filled" className={classes.formControl} fullWidth size="small"
                            required >
                            <InputLabel id="demo-simple-select-label">ماه</InputLabel>
                            <Select
                                value={month}
                                onChange={e => setMonth(e.target.value)}
                            >
                                <MenuItem value={1}>فروردین</MenuItem>
                                <MenuItem value={2}>اردیبهشت</MenuItem>
                                <MenuItem value={3}>خرداد</MenuItem>
                                <MenuItem value={4}>تیر</MenuItem>
                                <MenuItem value={5}>مرداد</MenuItem>
                                <MenuItem value={6}>شهریور</MenuItem>
                                <MenuItem value={7}>مهر</MenuItem>
                                <MenuItem value={8}>آبان</MenuItem>
                                <MenuItem value={9}>آذر</MenuItem>
                                <MenuItem value={10}>دی</MenuItem>
                                <MenuItem value={11}>بهمن</MenuItem>
                                <MenuItem value={12}>اسفند</MenuItem>
                            </Select>
                        </FormControl>

                    </Grid>
                    <Grid item xs={4}>
                        <TextField label="سال تولد" type="number" size="small" variant="filled" fullWidth
                            inputRef={yearOfBirthRef} required
                            InputLabelProps={{}} inputProps={{ min: 1300, max: 1400 }} />

                    </Grid>
                </Grid>
            </div>
            <div className={classes.input}>
                <FormControl variant="filled" className={classes.formControl} fullWidth size="small">
                    <InputLabel id="demo-simple-select-label">استان</InputLabel>
                    <Select
                        value={province}
                        onChange={e => setProvince(e.target.value)}
                    >
                        <MenuItem value={1}>آذربايجان شرقی</MenuItem>
                        <MenuItem value={2}>آذربايجان غربی</MenuItem>
                        <MenuItem value={3}>اردبيل</MenuItem>
                        <MenuItem value={4}>اصفهان</MenuItem>
                        <MenuItem value={5}>البرز</MenuItem>
                        <MenuItem value={6}>ايلام</MenuItem>
                        <MenuItem value={7}>بوشهر</MenuItem>
                        <MenuItem value={8}>تهران</MenuItem>
                        <MenuItem value={9}>چهارمحال و بختياری</MenuItem>
                        <MenuItem value={10}>خراسان جنوبی</MenuItem>
                        <MenuItem value={11}>خراسان رضوی</MenuItem>
                        <MenuItem value={12}>خراسان شمالی</MenuItem>
                        <MenuItem value={13}>خوزستان</MenuItem>
                        <MenuItem value={14}>زنجان</MenuItem>
                        <MenuItem value={15}>سيستان و بلوچستان	</MenuItem>
                        <MenuItem value={16}>فارس</MenuItem>
                        <MenuItem value={17}>قزوين</MenuItem>
                        <MenuItem value={18}>قم</MenuItem>
                        <MenuItem value={19}>اسفند</MenuItem>
                        <MenuItem value={20}>كردستان</MenuItem>
                        <MenuItem value={21}>كرمان</MenuItem>
                        <MenuItem value={22}>كرمانشاه</MenuItem>
                        <MenuItem value={23}>کهکيلويه و بويراحمد</MenuItem>
                        <MenuItem value={24}>گلستان</MenuItem>
                        <MenuItem value={25}>گیلان</MenuItem>
                        <MenuItem value={26}>لرستان</MenuItem>
                        <MenuItem value={27}>مازندران</MenuItem>
                        <MenuItem value={28}>مركزی</MenuItem>
                        <MenuItem value={29}>هرمزگان</MenuItem>
                        <MenuItem value={30}>همدان</MenuItem>
                        <MenuItem value={31}>يزد</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div className={classes.input}>
                <TextField label="شماره همراه" variant="filled" size="small" fullWidth
                    inputRef={phoneNumberRef} required />
            </div>
            <div className={classes.input}>
                <TextField label="کد IEMI" variant="filled" size="small" fullWidth
                    inputRef={imeiRef} required />
            </div>
            <Button variant="contained" color="primary" className={classes.button}
                fullWidth onClick={handleSubmit} type="submit">فعال‌سازی</Button>
        </form>

    )
}

const useStyles = makeStyles(theme => ({
    root: {
        textAlign: 'center',
        border: 'none',
        padding: theme.spacing(3, 10, 3, 10),
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(2, 4, 2, 4),
        },
    },
    title: {
        paddingBottom: theme.spacing(4),
        [theme.breakpoints.down('sm')]: {
            paddingBottom: theme.spacing(4),
        },
    },
    input: {
        margin: theme.spacing(2, 0),
    },
    button: {
        marginTop: theme.spacing(4),
        color: 'white'
    },
    text: {
        marginTop: theme.spacing(10)
    },
    formControl: {
        textAlign: 'start'
        // margin: theme.spacing(1),
    },
}))
